import CustomAppService from "../services/customapps";
import AppUsersService from "../services/appusers";

export const REQUEST_FAILED = "REQUEST_FAILED";
export const REQUEST_GET_CUSTOM_APP_TEMPLATE =
  "REQUEST_GET_CUSTOM_APP_TEMPLATE";
export const REFRESH_CUSTOM_APP_TEMPLATE = "REFRESH_CUSTOM_APP_TEMPLATE";
export const REQUEST_GET_CUSTOM_APP = "REQUEST_GET_CUSTOM_APP";
export const REQUEST_UPDATE_CUSTOM_APP = "REQUEST_UPDATE_CUSTOM_APP";
export const REFRESH_CUSTOM_APP = "REFRESH_CUSTOM_APP";
export const GET_USER_ACTIVITY_FOR_CUSTOM_APP =
  "GET_USER_ACTIVITY_FOR_CUSTOM_APP";
export const REFRESH_CUSTOM_APP_USER_ACTIVITY =
  "REFRESH_CUSTOM_APP_USER_ACTIVITY";
export const DELETE_USER_ACTIVITY_FOR_CUSTOM_APP =
  "DELETE_USER_ACTIVITY_FOR_CUSTOM_APP";
export const REQUEST_GET_CUSTOM_APP_GOAL = "GET_CUSTOM_APP_GOAL";
export const REFRESH_CUSTOM_APP_GOAL = "REFRESH_CUSTOM_APP_GOAL";
export const REQUEST_ADD_CUSTOM_APP_GOAL_PROGRESS =
  "REQUEST_ADD_CUSTOM_APP_GOAL_PROGRESS";

const requestFailed = (error) => ({
  type: REQUEST_FAILED,
  error,
});

const requestGetCustomAppTemplate = () => ({
  type: REQUEST_GET_CUSTOM_APP_TEMPLATE,
});

const refreshCustomAppTemplate = (appId, appTemplate) => ({
  type: REFRESH_CUSTOM_APP_TEMPLATE,
  appId,
  appTemplate,
});

const requestGetCustomApp = () => ({
  type: REQUEST_GET_CUSTOM_APP,
});

const requestUpdateCustomApp = () => ({
  type: REQUEST_UPDATE_CUSTOM_APP,
});

const refreshCustomApp = (
  appId,
  appUserId,
  customApp,
  programInstructions
) => ({
  type: REFRESH_CUSTOM_APP,
  appId,
  appUserId,
  customApp,
  programInstructions,
});

const requestGetUserActivityForCustomApp = (userId, customAppId) => ({
  type: GET_USER_ACTIVITY_FOR_CUSTOM_APP,
  userId,
  customAppId,
});

const refreshUserActivityForCustomApp = (
  userId,
  customAppId,
  userActivity
) => ({
  type: REFRESH_CUSTOM_APP_USER_ACTIVITY,
  userId,
  customAppId,
  userActivity,
});

const deleteUserActivityFromStore = (
  userId,
  appId,
  customAppId,
  activityId,
  ptsTotal
) => ({
  type: DELETE_USER_ACTIVITY_FOR_CUSTOM_APP,
  userId,
  appId,
  customAppId,
  activityId,
  ptsTotal,
});

const refreshCustomAppGoal = (customAppId, goal) => ({
  type: REFRESH_CUSTOM_APP_GOAL,
  customAppId,
  goal,
});

const requestGetCustomAppGoal = () => ({
  type: REQUEST_GET_CUSTOM_APP_GOAL,
});

const requestAddCustomAppGoalProgress = () => ({
  type: REQUEST_ADD_CUSTOM_APP_GOAL_PROGRESS,
});

export const fetchCustomApp = (appId, appUserId) => async (dispatch) => {
  dispatch(requestGetCustomApp(appId, appUserId));

  try {
    const response = await CustomAppService().getCustomApp(appId, appUserId);

    if (response.customApp) {
      dispatch(
        refreshCustomApp(
          appId,
          appUserId,
          response.customApp,
          response.programInstructions
        )
      );
    } else {
      dispatch(requestFailed("Unable to get custom app"));
    }
  } catch (error) {
    console.error("Failed to get custom app", error);
    dispatch(requestFailed("Internal error"));
  }
};

export const getCustomAppTemplate = (appId) => async (dispatch) => {
  dispatch(requestGetCustomAppTemplate(appId));

  try {
    const response = await CustomAppService().getCustomAppTemplate(appId);

    if (response.appTemplate) {
      dispatch(refreshCustomAppTemplate(appId, response.appTemplate));
    } else {
      dispatch(requestFailed("Unable to get custom app template"));
    }
  } catch (error) {
    console.error("Failed to get custom app template", error);
    dispatch(requestFailed("Internal error"));
  }
};

export const addCategoriesToCustomApp =
  (appId, appUserId, customAppId, categoryIDs) => async (dispatch) => {
    try {
      dispatch(requestUpdateCustomApp());
      const response = await CustomAppService().addCategoriesToCustomApp(
        customAppId,
        categoryIDs
      );

      if (response.customApp) {
        dispatch(
          refreshCustomApp(
            appId,
            appUserId,
            response.customApp,
            response.programInstructions
          )
        );
      } else {
        dispatch(requestFailed("Unable to add categories to custom app"));
      }
    } catch (error) {
      console.log("Adding categories to custom app Request Failed", error);
      dispatch(requestFailed("Internal error"));
    }
  };

export const addUserCategoryToCustomApp =
  (appId, appUserId, customAppId, newCategory) => async (dispatch) => {
    try {
      dispatch(requestUpdateCustomApp());
      const response = await CustomAppService().addUserCategoryToCustomApp(
        customAppId,
        newCategory
      );

      if (response.customApp) {
        dispatch(
          refreshCustomApp(
            appId,
            appUserId,
            response.customApp,
            response.programInstructions
          )
        );
      } else {
        dispatch(requestFailed("Unable to add user category to custom app"));
      }
    } catch (error) {
      console.log("Adding user category to custom app Request Failed", error);
      dispatch(requestFailed("Internal error"));
    }
  };

export const editCustomAppCategory =
  (appId, appUserId, customAppId, categoryId, category) => async (dispatch) => {
    try {
      dispatch(requestUpdateCustomApp());
      const response = await CustomAppService().editCustomAppCategory(
        customAppId,
        categoryId,
        category
      );

      if (response.customApp) {
        dispatch(
          refreshCustomApp(
            appId,
            appUserId,
            response.customApp,
            response.programInstructions
          )
        );
      } else {
        dispatch(requestFailed("Unable to edit category"));
      }
    } catch (error) {
      console.log("Updating category Request Failed", error);
      dispatch(requestFailed("Internal error"));
    }
  };

export const removeCategoriesFromCustomApp =
  (appId, appUserId, customAppId, categoryIDs) => async (dispatch) => {
    try {
      dispatch(requestUpdateCustomApp());
      const response = await CustomAppService().removeCategoriesFromCustomApp(
        customAppId,
        categoryIDs
      );

      if (response.customApp) {
        dispatch(
          refreshCustomApp(
            appId,
            appUserId,
            response.customApp,
            response.programInstructions
          )
        );
      } else {
        dispatch(requestFailed("Unable to remove categories from custom app"));
      }
    } catch (error) {
      console.log("Removing categories to custom app Request Failed", error);
      dispatch(requestFailed("Internal error"));
    }
  };

export const getUserActivityForCustomApp =
  (userId, customAppId) => async (dispatch) => {
    dispatch(requestGetUserActivityForCustomApp(userId, customAppId));

    try {
      const result = await AppUsersService().getUserActivityForCustomApp(
        userId,
        customAppId
      );
      if (result && result.activityList) {
        dispatch(
          refreshUserActivityForCustomApp(
            userId,
            customAppId,
            result.activityList
          )
        );
      } else {
        dispatch(
          requestFailed("Unable to get users activities for custom app!")
        );
      }
    } catch (error) {
      dispatch(requestFailed("Internal error!"));
    }
  };

export const deleteActivityFromCustomApp =
  (userId, activityId, customAppId, appId) => async (dispatch) => {
    dispatch(requestUpdateCustomApp());
    try {
      const result = await AppUsersService().deleteUserActivityForCustomApp(
        userId,
        activityId,
        customAppId
      );
      if (result && result) {
        dispatch(
          deleteUserActivityFromStore(
            userId,
            appId,
            customAppId,
            activityId,
            result.ptsTotal
          )
        );
      } else {
        dispatch(
          requestFailed("Unable to delete users activities for custom app!")
        );
      }
    } catch (error) {
      dispatch(requestFailed("Internal error!"));
    }
  };

export const getCustomAppGoal = (customAppId) => async (dispatch) => {
  dispatch(requestGetCustomAppGoal(customAppId));

  try {
    const response = await CustomAppService().getCustomAppGoal(customAppId);
    if (response.userGoal) {
      dispatch(refreshCustomAppGoal(customAppId, response.userGoal));
    } else {
      dispatch(requestFailed("Unable to get custom app goal"));
    }
  } catch (error) {
    dispatch(requestFailed("getCustomAppGoal Internal error" + error));
  }
};

export const addCustomAppGoal =
  (customAppId, goal, startDate, endDate) => async (dispatch) => {
    try {
      const response = await CustomAppService().addCustomAppGoal(
        customAppId,
        goal,
        startDate,
        endDate
      );

      if (response.userGoal) {
        dispatch(refreshCustomAppGoal(customAppId, response.userGoal));
      } else {
        dispatch(requestFailed("Unable to add custom app goal progress"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error"));
    }
  };

export const updateCustomAppGoal =
  (customAppId, goalId, goal, startDate, endDate, percentageCompleted) =>
  async (dispatch) => {
    try {
      dispatch(requestUpdateCustomApp());

      const response = await CustomAppService().updateCustomAppGoal(
        customAppId,
        goalId,
        goal,
        startDate,
        endDate,
        percentageCompleted
      );

      if (response.userGoal) {
        dispatch(refreshCustomAppGoal(customAppId, response.userGoal));
      } else {
        dispatch(requestFailed("Unable to update custom app goal"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error"));
    }
  };

export const removeCustomAppGoal =
  (customAppId, goalId) => async (dispatch) => {
    try {
      dispatch(requestUpdateCustomApp());

      const response = await CustomAppService().removeCustomAppGoal(
        customAppId,
        goalId
      );

      if (response.userGoal) {
        dispatch(refreshCustomAppGoal(customAppId, response.userGoal));
      } else {
        dispatch(requestFailed("Unable to remove custom app goal"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error"));
    }
  };

export const addCustomAppGoalProgress =
  (goalId, description, attachmentList, createdByProvider) =>
  async (dispatch) => {
    try {
      dispatch(
        requestAddCustomAppGoalProgress(
          goalId,
          description,
          attachmentList,
          createdByProvider
        )
      );

      const response = await CustomAppService().addCustomAppGoalProgress(
        goalId,
        description,
        attachmentList,
        createdByProvider
      );
      if (response.userGoal) {
        dispatch(
          refreshCustomAppGoal(response.userGoal.customAppId, response.userGoal)
        );
      } else {
        dispatch(requestFailed("Unable to add custom app goal progress"));
      }
    } catch (error) {
      dispatch(requestFailed("Internal error"));
    }
  };

export const reorderCustomAppCategories =
  (appId, appUserId, customAppId, categoryIDs) => async (dispatch) => {
    try {
      dispatch(requestUpdateCustomApp());

      const response = await CustomAppService().reorderCustomAppCategories(
        customAppId,
        categoryIDs
      );

      if (response.customApp) {
        dispatch(
          refreshCustomApp(
            appId,
            appUserId,
            response.customApp,
            response.programInstructions
          )
        );
      } else {
        dispatch(requestFailed("Unable to reorder categories of custom app"));
      }
    } catch (error) {
      //console.log('Reordering categories of custom app Request Failed', error);
      dispatch(requestFailed("Internal error"));
    }
  };



// WEBPACK FOOTER //
// ./src/actions/customapps.js